/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose, withState, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import { withLocalization } from 'hocs/localization'
import { onResendConfirmEmail } from 'redux-app/actionCreators/users'
import {
  isUserConfirmedEmail,
  isPlanAcceptedMessageShown,
  isCardExpired,
  getSubscriptionStatus,
  isPrinterWillBeSentSoon,
  isRenewalProcessAvailable,
  isSubscriptionRenewed,
  isEnrollAvailable,
  getUserFutureSubscription,
} from 'redux-app/selectors/user'
import { getEPSONContacts } from 'redux-app/selectors/contacts'
import Notifications from './Notifications'
import { getActiveNotificationNames } from './utils'
import { EMPTY_OBJECT } from 'constants/frozenObjects'

const getActiveNotifications = createSelector(
  getSubscriptionStatus,
  isPlanAcceptedMessageShown,
  isUserConfirmedEmail,
  isCardExpired,
  isPrinterWillBeSentSoon,
  isRenewalProcessAvailable,
  isSubscriptionRenewed,
  isEnrollAvailable,
  getUserFutureSubscription,
  (
    subscriptionStatus,
    isPlanAcceptedMessageShown,
    isUserConfirmedEmail,
    isCardExpired,
    isPrinterWillBeSentSoon,
    isRenewalProcessAvailable,
    isSubscriptionRenewed,
    isEnrollAvailable,
  ) =>
    getActiveNotificationNames({
      subscriptionStatus,
      isPlanAcceptedMessageShown,
      isUserConfirmedEmail,
      isCardExpired,
      isPrinterWillBeSentSoon,
      isRenewalProcessAvailable,
      isSubscriptionRenewed,
      isEnrollAvailable,
    }),
)

export default compose(
  withLocalization('profile.view.notifications'),
  connect(
    state => {
      const futureSubscription = getUserFutureSubscription(state) || EMPTY_OBJECT

      return {
        items: getActiveNotifications(state),
        contacts: getEPSONContacts(state),
        futureSubscription
      }
    },
    {
      onResendConfirmEmail,
    },
  ),
  withState('isResendingEmail', 'setResendingStatus', false),
  withHandlers({
    onResend: ({ onResendConfirmEmail, setResendingStatus }) => event => {
      event.preventDefault()
      setResendingStatus(true)
      onResendConfirmEmail()
        .then(() => {
          setResendingStatus(false)
        })
        .catch(() => {
          setResendingStatus(false)
        })
    },
  }),
)(Notifications)
